import { render, staticRenderFns } from "./TransactionEventTicketPurchase.vue?vue&type=template&id=49ff29b8&"
import script from "./TransactionEventTicketPurchase.vue?vue&type=script&lang=ts&"
export * from "./TransactionEventTicketPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports